function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.6613 10.7602L26.255 0.339191C26.0382 0.122013 25.7441 0 25.4375 0H3.46875C1.5561 0 0 1.55831 0 3.47368V40.5263C0 42.4418 1.5561 44 3.46875 44H33.5312C35.444 44 37 42.4418 37 40.5263V11.5789C37 11.2718 36.8782 10.9773 36.6613 10.7602ZM34.2086 11.5789H26.5938C25.9562 11.5789 25.4375 11.0595 25.4375 10.4211V2.79538L34.2086 11.5789ZM3.46875 41.6842H33.5312C34.1688 41.6842 34.6875 41.1647 34.6875 40.5263V13.8947H26.5938C24.681 13.8947 23.125 12.3364 23.125 10.4211V2.31579H3.46875C2.83122 2.31579 2.3125 2.83525 2.3125 3.47368V40.5263C2.3125 41.1647 2.83122 41.6842 3.46875 41.6842Z",
  fill: "#A5A5A5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.9062 20.8423H8.09375C7.45521 20.8423 6.9375 21.3607 6.9375 22.0002V35.8949C6.9375 36.5344 7.45521 37.0528 8.09375 37.0528H28.9062C29.5449 37.0528 30.0625 36.5344 30.0625 35.8949V22.0002C30.0625 21.3607 29.5449 20.8423 28.9062 20.8423ZM27.75 27.7897H23.125V23.1581H27.75V27.7897ZM16.1875 23.1581V27.7897H20.8125V23.1581H16.1875ZM20.8125 30.1054V34.737H16.1875V30.1054H20.8125ZM13.875 27.7897V23.1581H9.25V27.7897H13.875ZM9.25 30.1054H13.875V34.737H9.25V30.1054ZM23.125 30.1054V34.737H27.75V30.1054H23.125Z",
  fill: "#A5A5A5"
});

var SvgXlsIcon = function SvgXlsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 44,
    viewBox: "0 0 37 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgXlsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/xls-icon.d866c27e.svg";
export { ForwardRef as ReactComponent };